/* ==========================================================================
   NAUGHTY CITEES - INDEX MAP

   Places published sheets on the index diagram using the same Albers
   Equal Area Conic projection the outline was generated with. Constants
   are the standard USGS parameters for the continental United States.

   SCALE, OFFX and OFFY are the fit values from the generation pass that
   produced the outline path. They must not be edited independently of
   that path, or markers will drift off the coastline.

   Because positions are computed from real GNIS coordinates, a new sheet
   appears on the index the moment its metafields are set. Nothing is
   placed by hand.
   ========================================================================== */

(function () {
  'use strict';

  var LAT0 = 37.5, LON0 = -96.0, LAT1 = 29.5, LAT2 = 45.5;
  var rad = function (d) { return d * Math.PI / 180; };
  var n = 0.5 * (Math.sin(rad(LAT1)) + Math.sin(rad(LAT2)));
  var C = Math.pow(Math.cos(rad(LAT1)), 2) + 2 * n * Math.sin(rad(LAT1));
  var rho0 = Math.sqrt(C - 2 * n * Math.sin(rad(LAT0))) / n;

  var SCALE = 1304.2260169921612;
  var OFFX = 510.2318179707184;
  var OFFY = 337.1415411037197;

  function project(lon, lat) {
    var theta = n * rad(lon - LON0);
    var rho = Math.sqrt(C - 2 * n * Math.sin(rad(lat))) / n;
    return {
      x: rho * Math.sin(theta) * SCALE + OFFX,
      y: (rho * Math.cos(theta) - rho0) * SCALE + OFFY
    };
  }

  function svgEl(name, attrs) {
    var el = document.createElementNS('http://www.w3.org/2000/svg', name);
    for (var k in attrs) el.setAttribute(k, attrs[k]);
    return el;
  }

  function init() {
    var section = document.querySelector('.nc-map');
    if (!section) return;

    var group = section.querySelector('[data-nc-markers]');
    var dataEl = section.querySelector('[data-nc-sheets]');
    if (!group || !dataEl) return;

    var sheets = [];
    try { sheets = JSON.parse(dataEl.textContent) || []; }
    catch (e) { sheets = []; }

    if (!sheets.length) {
      section.classList.add('nc-map--empty');
      return;
    }

    var readout = section.querySelector('[data-nc-readout]');
    var key = section.querySelector('[data-nc-key]');
    var f = {
      no: section.querySelector('[data-nc-r-no]'),
      name: section.querySelector('[data-nc-r-name]'),
      state: section.querySelector('[data-nc-r-state]'),
      coords: section.querySelector('[data-nc-r-coords]'),
      county: section.querySelector('[data-nc-r-county]'),
      elev: section.querySelector('[data-nc-r-elev]'),
      quad: section.querySelector('[data-nc-r-quad]')
    };

    function pad(v) {
      var s = v ? String(v) : '--';
      return s.length < 2 ? '0' + s : s;
    }

    function show(s) {
      if (!readout) return;
      if (f.no) f.no.textContent = 'Sheet No. ' + pad(s.n);
      if (f.name) f.name.textContent = s.name || '';
      if (f.state) f.state.textContent = s.state || '';
      if (f.coords) f.coords.textContent = s.coords || 'Not recorded';
      if (f.county) f.county.textContent = s.county ? s.county + ' County' : 'Not recorded';
      if (f.elev) f.elev.textContent = s.elev ? s.elev + ' ft' : 'Not recorded';
      if (f.quad) f.quad.textContent = s.quad || 'Not recorded';
      readout.hidden = false;
      if (key) key.hidden = true;
    }

    function clear() {
      if (readout) readout.hidden = true;
      if (key) key.hidden = false;
    }

    sheets.forEach(function (s) {
      var p = project(s.lon, s.lat);
      if (!isFinite(p.x) || !isFinite(p.y)) return;

      var num = pad(s.n);

      var a = svgEl('a', { class: 'nc-map__marker', tabindex: '0' });
      a.setAttribute('href', s.url);
      a.setAttribute('aria-label',
        'Sheet ' + num + ', ' + (s.name || '') + (s.state ? ', ' + s.state : ''));

      // Locator cross, as on a survey index.
      a.appendChild(svgEl('path', {
        class: 'nc-map__cross',
        d: 'M' + (p.x - 7).toFixed(1) + ',' + p.y.toFixed(1) + 'H' + (p.x + 7).toFixed(1) +
           'M' + p.x.toFixed(1) + ',' + (p.y - 7).toFixed(1) + 'V' + (p.y + 7).toFixed(1)
      }));

      // Quadrangle rectangle carrying the sheet number.
      a.appendChild(svgEl('rect', {
        class: 'nc-map__quad',
        x: (p.x - 11).toFixed(1),
        y: (p.y - 9).toFixed(1),
        width: 22,
        height: 18
      }));

      var t = svgEl('text', {
        class: 'nc-map__num',
        x: p.x.toFixed(1),
        y: (p.y + 4).toFixed(1),
        'text-anchor': 'middle'
      });
      t.textContent = num;
      a.appendChild(t);

      a.addEventListener('mouseenter', function () { show(s); });
      a.addEventListener('focus', function () { show(s); });
      a.addEventListener('mouseleave', clear);
      a.addEventListener('blur', clear);

      group.appendChild(a);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
